module.exports = {"620523100":"大像山镇","620523101":"新兴镇","620523102":"磐安镇","620523103":"六峰镇","620523104":"安远镇","620523105":"金山镇","620523106":"大石镇","620523107":"礼辛镇","620523108":"武家河镇","620523109":"大庄镇","620523110":"古坡镇","620523111":"八里湾镇","620523112":"西坪镇","620523200":"谢家湾乡","620523207":"白家湾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620523.json
// module id = 3050
// module chunks = 0